export enum PaymentType {
  CASH = 'Cash',
  VIRTUAL_POS = 'VirtualPos',
  TRANSFER_EFT = 'TransferEft',
  POS = 'Pos',
  CURRENT_ACCOUNT = 'CurrentAccount',
  PARO_GIFT_CARD = 'ParoGiftCard',
  CHIPPIN = 'Chippin',
  HOPI = 'Hopi',
  BKM = 'Bkm',
  RESIDUAL_HOPI = 'ResidualHopi',
  YKB_WORLD_PUAN = 'YkbWorldPuan',
  MIVENTO = 'Mivento',
  ADVANCE_PAYMENT = 'AdvancePayment',
  VIRTUAL_POS_WITHOUT3D = 'VirtualPosWithout3d',
  FULL_PAYMENT = 'FullPayment',
  HOLIDAY_SUPPORT_LOAN = 'HolidaySupportLoan',
  VIRTUAL_POS_WITH_INSTALLMENT_POSTPONEMENT = 'VirtualPosWithInstallmentPostponement',
  VIRTUAL_POS_POINT = 'VirtualPosPoint',
  WORLD_PAY = 'WorldPay',
  SETUR_CARD = 'SeturCard',
  GARANTI_PAY = 'GarantiPay',
  SETUR_KART_TRANSFER = 'SeturKartTransfer',
  SETUR_PUAN = 'SeturPuan',
  SHOP_AND_FLY = 'ShopAndFly',
}
